import PropTypes from "prop-types";

import { countryCodes, formFieldNames } from "@/constants/emlakjet-link";
import IconArrow from "assets/svg/chevron_right_black.svg";

import styles from "./styles.module.css";

const PhoneInput = ({ hasError, phoneNumber, dialCode = "+90", handleFormValues, isMobileIos = false }) => {
  const { PHONE, COUNTRY_PHONE_CODE } = formFieldNames;
  const handleInputChange = ({ target }) => {
    let value = target.value.replace(/\D/g, "");

    if (value.length > 0) value = value.replace(/^(\d{3})(\d)/, "$1 $2");
    if (value.length > 6) value = value.replace(/^(\d{3})\s(\d{3})(\d)/, "$1 $2 $3");
    if (value.length > 9) value = value.replace(/^(\d{3})\s(\d{3})\s(\d{2})(\d)/, "$1 $2 $3 $4");

    if (value.length > 13) {
      value = value.slice(0, 13);
    }

    handleFormValues(PHONE, value);
  };

  const handleSelectChange = ({ target }) => handleFormValues(COUNTRY_PHONE_CODE, target.value);

  return (
    <div className={`${styles.container} ${hasError ? styles.error : ""}`}>
      <div className={styles.selectWrapper}>
        <select
          className={`${styles.select} ${dialCode ? styles.textBlack : styles.textGray}`}
          value={dialCode}
          onChange={handleSelectChange}
          style={{ fontSize: isMobileIos && "1rem" }}
        >
          {countryCodes.map((country) => (
            <option key={country.code} value={country.dialCode}>
              {country.code} {country.dialCode}
            </option>
          ))}
        </select>
        <div className={`${styles.svgIcon} ${dialCode ? styles.textBlack : styles.textGray}`}>
          <IconArrow />
        </div>
      </div>
      <input
        type="tel"
        placeholder="Telefon Numarası"
        className={`${styles.input} ${phoneNumber ? styles.textBlack : styles.textGray}`}
        value={phoneNumber}
        onInput={handleInputChange}
        maxLength={14}
        style={{ fontSize: isMobileIos && "1rem", paddingTop: isMobileIos && 5 }}
      />
    </div>
  );
};

PhoneInput.propTypes = {
  hasError: PropTypes.bool,
  phoneNumber: PropTypes.string,
  dialCode: PropTypes.string,
  handleFormValues: PropTypes.func,
  isMobileIos: PropTypes.bool,
};

export default PhoneInput;
